import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useEffect, useState } from 'react';
import { IconX, IconDeviceFloppy } from '@tabler/icons-react';
import { CurrencyInput } from '../../utils/CurrencyInput';

export default function TambahPengeluaran({
  // cabang,
  loadingSubmit,
  isOpenTambahPengeluaran,
  handleSubmitPengeluaran,
  nominal,
  setNominal,
  handleOnChange,
  closeModalTambahPengeluaran,
}) {
  const [selectedTipe, setSelectedTipe] = useState('');

  useEffect(() => {
    if (isOpenTambahPengeluaran == false) {
      setNominal(0);
      setSelectedTipe('');
    }
  }, [isOpenTambahPengeluaran]);

  const tipeOptions = [
    { label: 'Pemasukan', value: 'pemasukan' },
    { label: 'Tambah KAS', value: 'tambah-kas' },
    { label: 'Tarik KAS', value: 'tarik-kas' },
    { label: 'M-Banking', value: 'm-banking' },
    { label: 'Gaji Karyawan', value: 'gaji-karyawan' },
    { label: 'Listrik, Air & Telepon', value: 'listrik-air-telepon' },
    { label: 'Bensin, Parkir & Transportasi', value: 'bensin-parkir-transportasi' },
    { label: 'Makan & Minum', value: 'makan-minum' },
    { label: 'Donasi dan Santunan', value: 'donasi-santunan' },
    { label: 'Pengeluaran Lainnya', value: 'pengeluaran-lainnya' },
  ];


  function fake() { }

  return (
    <>
      <Transition appear show={isOpenTambahPengeluaran} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={fake}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-3 sm:p-4">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-lg transform overflow-visible bg-white rounded-lg text-left shadow-xl transition-all">
                  {/* Header */}
                  <div className="flex items-center justify-between px-4 py-3 sm:px-6 sm:py-4 border-b border-slate-200">
                    <div>
                      <Dialog.Title as="h3" className="text-base sm:text-lg font-semibold text-gray-900">
                        Masukkan Pengeluaran
                      </Dialog.Title>
                      <p className="text-[10px] sm:text-xs text-slate-500 mt-0.5">Isi data transaksi pengeluaran.</p>
                    </div>
                    <button
                      type="button"
                      onClick={closeModalTambahPengeluaran}
                      className="p-1.5 rounded-md hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition-colors"
                      title="Tutup"
                    >
                      <IconX className="w-5 h-5" />
                    </button>
                  </div>

                  {/* Body */}
                  <div className="px-4 py-4 sm:px-6 sm:py-5 space-y-4">
                    {/* Judul */}
                    <div>
                      <label htmlFor="judul" className="block text-xs sm:text-sm font-semibold text-slate-800 mb-1">
                        Judul
                      </label>
                      <input
                        type="text"
                        id="judul"
                        name="title"
                        onChange={handleOnChange}
                        className="w-full border border-slate-300 bg-white px-3 py-3 sm:py-2.5 text-sm rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500/40"
                        placeholder="Masukkan judul pengeluaran"
                        required
                        autoComplete="off"
                      />
                    </div>

                    {/* Nominal */}
                    <div>
                      <label htmlFor="nominal" className="block text-xs sm:text-sm font-semibold text-slate-800 mb-1">
                        Nominal
                      </label>
                      <CurrencyInput
                        name="nominal"
                        value={nominal}
                        autoComplete="off"
                        onChange={(value) => setNominal(value)}
                        className="w-full border border-slate-300 bg-white px-3 py-3 sm:py-2.5 text-sm rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500/40"
                      />
                      <p className="text-[10px] sm:text-xs text-slate-500 mt-1">Otomatis berformat mata uang.</p>
                    </div>

                    {/* Tipe */}
                    <div>
                      <label htmlFor="tipe" className="block text-xs sm:text-sm font-semibold text-slate-800 mb-1">
                        Tipe
                      </label>
                      <select
                        value={selectedTipe}
                        onChange={(e) => {
                          setSelectedTipe(e.target.value);
                          handleOnChange({ target: { name: 'tipe', value: e.target.value } });
                        }}
                        className="w-full border border-slate-300 bg-white px-3 py-3 sm:py-2.5 text-sm rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500/40 cursor-pointer"
                      >
                        <option value="">Pilih Tipe Transaksi</option>
                        {tipeOptions.map((item) => (
                          <option key={item.value} value={item.value}>{item.label}</option>
                        ))}
                      </select>
                    </div>

                    {/* Keterangan */}
                    <div>
                      <label htmlFor="message" className="block text-xs sm:text-sm font-semibold text-slate-800 mb-1">
                        Keterangan
                      </label>
                      <textarea
                        id="message"
                        onChange={handleOnChange}
                        rows={3}
                        name="keterangan"
                        className="w-full border border-slate-300 bg-white px-3 py-3 sm:py-2.5 text-sm rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500/40"
                        placeholder="Catatan tambahan (bila ada)..."
                      />
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="flex items-center justify-end gap-2 px-4 py-3 sm:px-6 sm:py-4 border-t border-slate-200 bg-slate-50 rounded-b-lg">
                    <button
                      type="button"
                      onClick={closeModalTambahPengeluaran}
                      className="px-4 py-2.5 sm:py-2 text-sm font-semibold bg-white hover:bg-slate-100 text-slate-700 border border-slate-300 rounded-md transition-colors flex items-center gap-2"
                    >
                      <IconX className="w-4 h-4" />
                      Batal
                    </button>
                    <button
                      type="submit"
                      onClick={handleSubmitPengeluaran}
                      disabled={loadingSubmit}
                      className="px-5 py-2.5 sm:py-2 text-sm font-semibold text-white bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 rounded-md shadow-sm disabled:from-slate-300 disabled:to-slate-300 disabled:text-slate-500 disabled:cursor-not-allowed disabled:shadow-none transition-all flex items-center gap-2"
                    >
                      <IconDeviceFloppy className="w-4 h-4" />
                      {loadingSubmit ? 'Proses...' : 'Simpan'}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
